import { Link } from "react-router-dom";

import { useI18n } from "../i18n/I18nProvider.js";
import { Icon } from "./Icon.js";

/** Read-only shell. Real numbers must arrive through the reviewed bundle pipeline. */
export function EmergencyContactReference() {
  const { t } = useI18n();

  const draftContacts = [
    {
      number: "1669",
      title: t("contacts.draft.medical"),
      scope: t("contacts.draft.medical_scope"),
      source: "https://www.niems.go.th/1/News/Detail/1118?group=2",
      authority: "NIEM",
    },
    {
      number: "191",
      title: t("contacts.draft.police"),
      scope: t("contacts.draft.police_scope"),
      source: "https://www.191.go.th/th",
      authority: "191 Pan Fah / RTP",
    },
    {
      number: "199",
      title: t("contacts.draft.fire"),
      scope: t("contacts.draft.fire_scope"),
      source: "https://info.go.th/emergency-number",
      authority: "Thailand Government Directory",
    },
  ] as const;

  return (
    <section aria-labelledby="contact-reference-title" className="contact-reference">
      <p className="contact-reference__eyebrow">{t("contacts.reference.eyebrow")}</p>
      <h2 id="contact-reference-title">{t("contacts.reference.title")}</h2>
      <p className="contact-reference__review">{t("contacts.draft.warning")}</p>
      <div className="contact-reference__list">
        {draftContacts.map((contact) => (
          <article className="contact-reference__item" key={contact.number}>
            <strong className="contact-reference__number">{contact.number}</strong>
            <div>
              <h3>{contact.title}</h3>
              <p>{contact.scope}</p>
              <a href={contact.source} rel="noreferrer" target="_blank">
                {t("contacts.draft.source")}: {contact.authority} ↗
              </a>
            </div>
            <span>{t("contacts.draft.status")}</span>
          </article>
        ))}
      </div>
      <Link className="contact-reference__directory-link" to="/contacts">
        <Icon name="book" />
        <span>{t("contacts.reference.directory_link")}</span>
        <span aria-hidden="true">→</span>
      </Link>
      <p>{t("contacts.draft.disaster_blocked")}</p>
      <p className="contact-reference__boundary">{t("contacts.reference.read_only")}</p>
    </section>
  );
}
